import { Navigation } from "@/components/Navigation";
import { Hero } from "@/components/Hero";
import { StatsOverview } from "@/components/StatsOverview";
import { RecentMatches } from "@/components/RecentMatches";
import { Footer } from "@/components/Footer";

export const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <Hero />
      <StatsOverview />
      <RecentMatches />
      <Footer />
    </div>
  );
};

export default HomePage;
